import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default from 'react';
import styled from 'styled-components';
import '../text/text.component.js';
import '../buttons/button.component.js';
import './wrapper.component.js';
import '../../App.css.js';
var _excluded = ["style", "width", "height", "children", "mobileTablet"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var Container = styled.div.withConfig({
  displayName: "card-wrappercomponent__Container",
  componentId: "sc-mpebi3-0"
})(["display:flex;max-width:1140px;width:100%;", " ", ""], function (props) {
  return props.mobileTablet ? "\n  @media screen and (max-width: 1000px) {\n    flex-direction: column;\n    padding-bottom: 48px;\n    & > div:not(:first-child) {\n      margin-top: 24px;\n    }\n  }" : "\n  @media screen and (max-width: 768px) {\n    flex-direction: column;\n    padding-bottom: 48px;\n    & > div:not(:first-child) {\n      margin-top: 24px;\n    }\n  }\n  ";
}, function (props) {
  return props.mobileTablet ? "\n  @media screen and (min-width: 1000px) {\n    padding-bottom: 192px;\n    ".concat(props.count == 2 ? "& > div:first-child{\n        margin-right: 32px;\n    }" : props.count == 3 ? "& > div:nth-child(2){\n        margin-left: 20px;\n        margin-right: 20px;\n    }" : props.count == 4 ? "& > div:nth-child(2){\n        margin-left: 16px;\n        margin-right: 16px;\n    }\n    & > div:nth-child(3){\n        margin-right: 16px;\n    }" : "", "\n  }\n  ") : "@media screen and (min-width: 768px) {\n  padding-bottom: 192px;\n  ".concat(props.count == 2 ? "& > div:first-child{\n      margin-right: 32px;\n  }" : props.count == 3 ? "& > div:nth-child(2){\n      margin-left: 20px;\n      margin-right: 20px;\n  }" : props.count == 4 ? "& > div:nth-child(2){\n      margin-left: 16px;\n      margin-right: 16px;\n  }\n  & > div:nth-child(3){\n      margin-right: 16px;\n  }" : "", "\n}\n");
});
var CardWrapper = function CardWrapper(_ref) {
  var style = _ref.style;
  _ref.width;
  _ref.height;
  var children = _ref.children,
    mobileTablet = _ref.mobileTablet;
  _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Container, {
    mobileTablet: mobileTablet,
    style: _objectSpread({}, style),
    count: children.length
  }, children);
};
export { CardWrapper as default };